import ___default from "lodash";
import { AnalysisTemplateTypeDto } from "@ane/exp-data/lib/resources/MetricServiceResource";
const isForayAppSettingsValid = (values) => {
  let errors = {};
  if (values.templateSelectedType === AnalysisTemplateTypeDto.ForayApp) {
    errors.customForayParameters = ___default.map(values.customForayParameters, (s, i) => {
      var _a;
      let insideError = {};
      if (!((_a = s.value) == null ? void 0 : _a.trim()) && s.isRequired) {
        insideError.value = "Required";
      }
      return insideError;
    });
    if (!___default.some(errors.customForayParameters, (s) => !!s.value)) {
      delete errors.customForayParameters;
    }
  }
  return errors;
};
export {
  isForayAppSettingsValid
};
//# sourceMappingURL=ForayAppSettingsForm.validation.js.map
